import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
    name: "ChatFormArrow"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  emits: ["click"],
  setup(__props, { emit: __emit }) {

let emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "arrow",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("span", null, "▼", -1)
  ])))
}
}

})